import React, { useContext, useEffect } from "react";
import { Route, Redirect } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";

export default function PrivateRoute({ component: Component, ...rest }) {
  const { glob_pay_agent_auth } = useContext(AuthContext);

  useEffect(() => {
    console.log("loooo", glob_pay_agent_auth.access_token);
  }, []);

  return (
    <>
      <Route
        {...rest}
        render={(props) =>
          glob_pay_agent_auth.access_token ? (
            <Component {...props} />
          ) : (
            <Redirect to="/login" />
          )
        }
      />
    </>
  );
}
